export function normalizeApiError(
  err,
  fallbackMessage = 'Ocurrió un error inesperado.'
) {
  const e = err?.originalError ?? err;

  const isAxios = !!e?.isAxiosError || !!e?.response || !!e?.request;

  const rawMessage = (e?.message || '').toLowerCase();

  if (rawMessage.includes('network error')) {
    return {
      type: 'danger',
      title: 'Sin conexión',
      message:
        'No fue posible conectarse al servidor. Revisa tu conexión e inténtalo nuevamente.',
    };
  }

  if (isAxios && !e?.response) {
    if (e?.code === 'ECONNABORTED') {
      return {
        type: 'danger',
        title: 'Tiempo de espera',
        message: 'La solicitud tardó demasiado. Intenta nuevamente.',
      };
    }

    return {
      type: 'danger',
      title: 'Sin conexión',
      message:
        'No fue posible conectarse al servidor. Revisa tu conexión e inténtalo nuevamente.',
    };
  }

  const status = e?.response?.status;
  const data = e?.response?.data;

  const backendMessage =
    (typeof data === 'string' && data) ||
    data?.message ||
    data?.title ||
    data?.error ||
    null;

  if (status === 400) {
    return {
      type: 'danger',
      title: 'Solicitud inválida',
      message:
        backendMessage ||
        'Verifica los datos ingresados e inténtalo nuevamente.',
    };
  }

  if (status === 401) {
    return {
      type: 'danger',
      title: 'Credenciales inválidas',
      message: backendMessage || 'Email o contraseña incorrectos.',
    };
  }

  if (status === 403) {
    return {
      type: 'danger',
      title: 'Acceso denegado',
      message: backendMessage || 'No tienes permisos para acceder.',
    };
  }

  if (status === 404) {
    return {
      type: 'danger',
      title: 'No encontrado',
      message: backendMessage || 'El recurso solicitado no existe.',
    };
  }

  if (status >= 500) {
    return {
      type: 'danger',
      title: 'Error del servidor',
      message:
        'Tenemos un problema en el servidor. Intenta nuevamente más tarde.',
    };
  }

  return {
    type: 'danger',
    title: 'Error',
    message: backendMessage || fallbackMessage,
  };
}
